import {REAL_ESTATE_AGENT, REAL_ESTATE_BROKER, MORTGAGE_LOAN_ORIGINATOR}
from "@milestoneslabs/milestones-core-js/src/AppResources/ProfessionalLicenseAppResource";
let map = {};

map[REAL_ESTATE_AGENT] = {
    AL: 'Alabama Real Estate Commission',
    AK: 'Alaska Real Estate Commission',
    AZ: 'Arizona Department of Real Estate',
    AR: 'Arkansas Real Estate Commission',
    CA: 'California Department of Real Estate',
    CO: 'Colorado Division of Real Estate',
    CT: 'Connecticut Department of Consumer Protection',
    DE: 'Delaware Real Estate Commission',
    DC: 'District of Columbia Real Estate Commission',
    FL: 'Florida Real Estate Commission',
    GA: 'Georgia Real Estate Commission',
    HI: 'Hawaii Real Estate Commission',
    ID: 'Idaho Real Estate Commission',
    IL: 'Illinois Department of Financial & Professional Regulation',
    IN: 'Indiana Real Estate Commission',
    IA: 'Iowa Real Estate Commission',
    KS: 'Kansas Real Estate Commission',
    KY: 'Kentucky Real Estate Commission',
    LA: 'Louisiana Real Estate Commission',
    ME: 'Maine Real Estate Commission',
    MD: 'Maryland Real Estate Commission',
    MA: 'Massachusetts Real Estate Board',
    MI: 'Michigan Department of Licensing and Regulatory Affairs',
    MN: 'Minnesota Commerce Department',
    MS: 'Mississippi Real Estate Commission',
    MO: 'Missouri Real Estate Commission',
    MT: 'Montana Department of Labor & Industry',
    NE: 'Nebraska Real Estate Commission',
    NV: 'Nevada Real Estate Division',
    NH: 'New Hampshire Real Estate Commission',
    NJ: 'New Jersey Real Estate Commission',
    NM: 'New Mexico Real Estate Commission',
    NY: 'Division of Licensing Services',
    NC: 'North Carolina Real Estate Commission',
    ND: 'North Dakota Real Estate Commission',
    OH: 'Ohio Division of Real Estate & Professional Licensing',
    OK: 'Oklahoma Real Estate Commission',
    OR: 'Oregon Real Estate Agency',
    PA: 'Pennsylvania Real Estate Commission',
    RI: 'State of Rhode Island, Department of Business Regulation',
    SC: 'South Carolina Real Estate Commission',
    SD: 'South Dakota Real Estate Commission',
    TN: 'Tennessee Real Estate Commission',
    TX: 'Texas Real Estate Commission',
    UT: 'Utah Division of Real Estate',
    VT: 'Vermont Real Estate Commission',
    VA: 'Virginia Real Estate Board',
    WA: 'Washington State Department of Licensing',
    WV: 'West Virginia Real Estate Commission',
    WI: 'Wisconsin Department of Safety and Professional Services',
    WY: 'Wyoming Real Estate Commission',
};

map[REAL_ESTATE_BROKER] = {
    AL: 'Alabama Real Estate Commission',
    AK: 'Alaska Real Estate Commission',
    AZ: 'Arizona Department of Real Estate',
    AR: 'Arkansas Real Estate Commission',
    CA: 'California Department of Real Estate',
    CO: 'Colorado Division of Real Estate',
    CT: 'Connecticut Department of Consumer Protection',
    DE: 'Delaware Real Estate Commission',
    DC: 'District of Columbia Real Estate Commission',
    FL: 'Florida Real Estate Commission',
    GA: 'Georgia Real Estate Commission',
    HI: 'Hawaii Real Estate Commission',
    ID: 'Idaho Real Estate Commission',
    IL: 'Illinois Department of Financial & Professional Regulation',
    IN: 'Indiana Real Estate Commission',
    IA: 'Iowa Real Estate Commission',
    KS: 'Kansas Real Estate Commission',
    KY: 'Kentucky Real Estate Commission',
    LA: 'Louisiana Real Estate Commission',
    ME: 'Maine Real Estate Commission',
    MD: 'Maryland Real Estate Commission',
    MA: 'Massachusetts Real Estate Board',
    MI: 'Michigan Department of Licensing and Regulatory Affairs',
    MN: 'Minnesota Commerce Department',
    MS: 'Mississippi Real Estate Commission',
    MO: 'Missouri Real Estate Commission',
    MT: 'Montana Department of Labor & Industry',
    NE: 'Nebraska Real Estate Commission',
    NV: 'Nevada Real Estate Division',
    NH: 'New Hampshire Real Estate Commission',
    NJ: 'New Jersey Real Estate Commission',
    NM: 'New Mexico Real Estate Commission',
    NY: 'Division of Licensing Services',
    NC: 'North Carolina Real Estate Commission',
    ND: 'North Dakota Real Estate Commission',
    OH: 'Ohio Division of Real Estate & Professional Licensing',
    OK: 'Oklahoma Real Estate Commission',
    OR: 'Oregon Real Estate Agency',
    PA: 'Pennsylvania Real Estate Commission',
    RI: 'State of Rhode Island, Department of Business Regulation',
    SC: 'South Carolina Real Estate Commission',
    SD: 'South Dakota Real Estate Commission',
    TN: 'Tennessee Real Estate Commission',
    TX: 'Texas Real Estate Commission',
    UT: 'Utah Division of Real Estate',
    VT: 'Vermont Real Estate Commission',
    VA: 'Virginia Real Estate Board',
    WA: 'Washington State Department of Licensing',
    WV: 'West Virginia Real Estate Commission',
    WI: 'Wisconsin Department of Safety and Professional Services',
    WY: 'Wyoming Real Estate Commission',
};

map[MORTGAGE_LOAN_ORIGINATOR] = {
    AL: 'Alabama State Banking Department',
    AK: 'Alaska Department of Commerce, Community & Economic Development: Division of Banking & Securities',
    AZ: 'Arizona Department of Insurance and Financial Institutions',
    AR: 'Arkansas Securities Department',
    CA: 'California Department of Financial Protection and Innovation​',
    CO: 'Colorado Division of Real Estate',
    CT: 'Connecticut Department of Banking',
    DE: 'Delaware Office of the State Bank Commissioner',
    DC: 'District of Columbia Department of Insurance, Securities, and Banking',
    FL: 'Florida Office of Financial Regulation',
    GA: 'Georgia Department of Banking and Finance',
    HI: 'Hawaii Division of Financial Institutions',
    ID: 'Idaho Department of Finance',
    IL: 'Illinois Department of Financial & Professional Regulation',
    IN: 'Indiana Department of Financial Institutions',
    IA: 'Iowa Division of Banking',
    KS: 'Kansas Office of the State Bank Commissioner',
    KY: 'Kentucky Department of Financial Institutions',
    LA: 'Louisiana Office of Financial Institutions',
    ME: 'Maine Bureau of Consumer Credit Protection',
    MD: 'Maryland Commissioner of Financial Regulation',
    MA: 'Massachusetts Division of Banks',
    MI: 'Michigan Department of Insurance and Financial Services',
    MN: 'Minnesota Department of Commerce',
    MS: 'Mississippi Department of Banking and Consumer Finance',
    MO: 'Missouri Division of Finance',
    MT: 'Montana Division of Banking & Financial Institutions',
    NE: 'Nebraska Department of Banking and Finance',
    NV: 'Nevada Division of Mortgage Lending',
    NH: 'New Hampshire Banking Department',
    NJ: 'New Jersey Department of Banking and Insurance',
    NM: 'New Mexico Financial Institutions Division',
    NY: 'New York Department of Financial Services',
    NC: 'North Carolina Commissioner of Banks Office',
    ND: 'North Dakota Department of Financial Institutions',
    OH: 'Ohio Division of Financial Institutions',
    OK: 'Oklahoma Department of Consumer Credit',
    OR: 'Oregon Division of Financial Regulation',
    PA: 'Pennsylvania Department of Banking and Securities',
    RI: 'State of Rhode Island Department of Business Regulation',
    SC: 'South Carolina Board of Financial Institutions',
    SD: 'South Dakota Division of Banking',
    TN: 'Tennessee Department of Financial Institutions',
    TX: 'Texas Department of Savings and Mortgage Lending',
    UT: 'Utah Department of Financial Institutions',
    VT: 'Vermont Department of Financial Regulation',
    VA: 'Virginia Bureau of Financial Institutions',
    WA: 'Washington Department of Financial Institutions',
    WV: 'West Virginia Division of Financial Institutions',
    WI: 'Wisconsin Department of Financial Institutions',
    WY: 'Wyoming Division of Banking',
};

export default map;
